import type { Permission } from "@pokifolio/contracts";
import type { ReactNode } from "react";

import { ForbiddenPage } from "../../app/status-pages";
import { useHasPermission } from "./session";

/** Hides a screen the user may not use. The API enforces the same rule; this only avoids confusion. */
export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  return useHasPermission(permission) ? children : <ForbiddenPage />;
}
